"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatDate = void 0;
const date_fns_1 = require("date-fns");
function formatDate(date) {
    return (0, date_fns_1.format)(date, "d MMM y | h m aa");
}
exports.formatDate = formatDate;
